/**
 * ヘッダー関連 Class
 */
export default class Header {
  constructor() {
    this.scrollEvent();
    this.scrollFixed();
    this.spNavigation();
  };

  /**
   * スクロールイベント
   */
  scrollEvent() {
    window.addEventListener('scroll', this.scrollFixed);
  };

  /**
   * 上部固定判定
   */
  scrollFixed() {
    let $scrollVal = $(window).scrollTop();
    if (0 < $scrollVal) {
      $('.l-header').addClass('is-fixed');
    } else {
      $('.l-header').removeClass('is-fixed');
    }
  };

  /**
   * スマホナビゲーション開閉
   */
  spNavigation() {
    let navOpen = function () {
      $('.l-header').addClass('is-open');
    }
    let navClose = function () {
      $('.l-header').removeClass('is-open');
    }
    $(document).on('click', '#js-nav-open', navOpen);
    $(document).on('click', '#js-nav-close', navClose);
    $(document).on('click', '#js-nav-bg', navClose);
    $('.l-header__nav--sp-child li a[href^="#"]').click(navClose);
  };
}
